import React from "react";
import { Dialog, DialogContent, Typography } from "@mui/material";
import { motion } from "framer-motion";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const ResultModal = ({ show, onClose, message }) => {
  return (
    <Dialog open={show} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogContent sx={{ textAlign: "center", p: 4 }}>
        {/* Animated Check Icon */}
        <motion.div
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
        >
          <CheckCircleIcon sx={{ fontSize: 80, color: "green" }} />
        </motion.div>

        {/* Success Message */}
        <Typography variant="h6" sx={{ mt: 2 }}>
          {message || "Operation Successful!"}
        </Typography>

        {/* Animated Closing */}
        <motion.button
          onClick={onClose}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          style={{
            marginTop: "20px",
            padding: "10px 20px",
            border: "none",
            borderRadius: "8px",
            background: "green",
            color: "white",
            fontSize: "16px",
            cursor: "pointer",
          }}
        >
          Fermer
        </motion.button>
      </DialogContent>
    </Dialog>
  );
};

export default ResultModal;
